export default "__VITE_ASSET__Dv8Tpim9__"